var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import flattenDeep from "lodash/flattenDeep";
import values from "lodash/values";
import { GET_INITIAL_OPTIONS, INITIAL_OPTIONS_FAIL, INITIAL_OPTIONS_SUCCESS, REMOVE_NOTIFICATION, RESET_STATE, SEND_FLASH_NOTIFICATION, SEND_VALIDATION_ERRORS, SET_APP_STATE, SET_PAYMENT_SESSION_ID, UPDATE_FILTERS, SET_PAYBOOK_REFERENCE_PAGE, UPDATE_CUSTOMER_ID, SET_CERTIFICATE_SESSION_ID } from "../actions";
export var appReducer = function (state, action) {
    var _a;
    if (state === void 0) { state = {
        customerId: null,
        flashNotifications: [],
        currentState: null,
        isFetching: false,
        initialData: null,
        error: null,
        queryString: "",
        payment_session_id: null,
        paybookReferencePage: null,
        validationErrors: null,
        integrationName: ""
    }; }
    var type = action.type, otherProps = __rest(action, ["type"]);
    switch (action.type) {
        case UPDATE_CUSTOMER_ID:
            return __assign(__assign({}, state), { customerId: action.customerId });
        case SEND_FLASH_NOTIFICATION:
            return __assign(__assign({}, state), { flashNotifications: flattenDeep(values(otherProps.notification)) });
        case REMOVE_NOTIFICATION:
            return __assign(__assign({}, state), { flashNotifications: state.flashNotifications.filter(function (x, i) { return i !== otherProps.index; }) });
        case SEND_VALIDATION_ERRORS:
            return __assign(__assign({}, state), { validationErrors: otherProps.validationErrors });
        case SET_APP_STATE:
            return __assign(__assign({}, state), { currentState: otherProps.state });
        case RESET_STATE:
            if (((_a = otherProps.payload) === null || _a === void 0 ? void 0 : _a.resetNotifications) === false) {
                return state;
            }
            return __assign(__assign({}, state), { flashNotifications: [] });
        case SET_PAYMENT_SESSION_ID:
            return __assign(__assign({}, state), otherProps);
        case SET_CERTIFICATE_SESSION_ID:
            return __assign(__assign({}, state), otherProps);
        case SET_PAYBOOK_REFERENCE_PAGE:
            return __assign(__assign({}, state), { paybookReferencePage: otherProps.paybookReferencePage });
        case UPDATE_FILTERS:
            return __assign(__assign({}, state), otherProps);
        case GET_INITIAL_OPTIONS:
            return __assign(__assign({}, state), { isFetching: true, initialData: null, error: null });
        case INITIAL_OPTIONS_SUCCESS:
        case INITIAL_OPTIONS_FAIL:
            return __assign(__assign(__assign({}, state), { isFetching: false }), otherProps);
        default:
            break;
    }
    return state;
};
